import React from 'react';
import { motion } from 'framer-motion';
import { LeafIcon, LotusIcon, SectionDivider } from './Icons';
export const RevelationSection = () => {
  return <section className="py-16 px-4 md:px-8 bg-white" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-172">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-creamAlt text-brand-green mb-6" data-id="element-173">
            <LotusIcon className="w-8 h-8" data-id="element-174" />
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal mb-6" data-id="element-175">
            El secreto no está en comer menos, sino en enviar señales de
            seguridad a tu sistema nervioso.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-176">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-brand-cream p-8 rounded-2xl border border-brand-green/10" data-id="element-177">
            <p className="text-lg text-brand-charcoal/90 mb-4" data-id="element-178">
              He descubierto que cuando dejas de contar calorías y empiezas a
              gestionar la Insulina y el Cortisol mediante el{' '}
              <strong className="text-brand-green" data-id="element-179">Timing Circadiano</strong> y
              la{' '}
              <strong className="text-brand-green" data-id="element-180">Densidad Nutricional</strong>
              , sucede algo milagroso:
            </p>
            <div className="flex items-center gap-3 mt-6 bg-white p-4 rounded-xl shadow-sm" data-id="element-181">
              <LeafIcon className="w-6 h-6 text-brand-green flex-shrink-0" data-id="element-182" />
              <p className="font-serif text-xl font-bold text-brand-green" data-id="element-183">
                El cuerpo finalmente se relaja.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="bg-brand-green text-white p-8 rounded-2xl shadow-lg flex flex-col justify-center" data-id="element-184">
            <p className="text-lg mb-6 opacity-90" data-id="element-185">
              Cuando el cuerpo se siente seguro, permite que la grasa se oxide,
              que el estrógeno residual se estabilice y que la inflamación
              desaparezca.
            </p>
            <p className="text-xl font-medium mb-2" data-id="element-186">No es magia,</p>
            <h3 className="text-3xl font-serif font-bold text-brand-gold" data-id="element-187">
              es Resiliencia Metabólica.
            </h3>
            <p className="mt-4 text-sm opacity-80 uppercase tracking-wider" data-id="element-188">
              Y es exactamente lo que vas a dominar en este sistema.
            </p>
          </motion.div>
        </div>

        <SectionDivider data-id="element-189" />
      </div>
    </section>;
};